import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/pages/HomePage.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/LoginPage.vue'),
      meta: { guestOnly: true }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/pages/RegisterPage.vue'),
      meta: { guestOnly: true }
    },
    {
      path: '/for-agents',
      name: 'for-agents',
      component: () => import('@/pages/AgentGuidePage.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('@/pages/LegalDocPage.vue'),
      props: { docKey: 'privacy-policy' }
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('@/pages/LegalDocPage.vue'),
      props: { docKey: 'terms-of-service' }
    },
    {
      path: '/security',
      name: 'security',
      component: () => import('@/pages/LegalDocPage.vue'),
      props: { docKey: 'security-data-handling' }
    },
    {
      path: '/data-deletion',
      name: 'data-deletion',
      component: () => import('@/pages/LegalDocPage.vue'),
      props: { docKey: 'data-deletion-account-deletion' }
    },
    {
      path: '/support',
      name: 'support',
      component: () => import('@/pages/LegalDocPage.vue'),
      props: { docKey: 'support-contact' }
    },
    {
      path: '/mfa-challenge',
      name: 'mfa-challenge',
      component: () => import('@/pages/MfaChallengePage.vue'),
      meta: { guestOnly: true }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/pages/DashboardPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/connect',
      name: 'connect',
      component: () => import('@/pages/ConnectPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/connect/oauth-return',
      name: 'plaid-oauth-return',
      component: () => import('@/pages/ConnectPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/grants',
      name: 'grants',
      component: () => import('@/pages/GrantsPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/oauth/authorize',
      name: 'oauth-authorize',
      component: () => import('@/pages/OAuthAuthorizePage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/mcp/authorize',
      name: 'mcp-authorize',
      component: () => import('@/pages/McpAuthorizePage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/audit',
      name: 'audit',
      component: () => import('@/pages/AuditPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/pages/SettingsPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/pages/NotFoundPage.vue')
    }
  ]
})

// Navigation guards
router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()

  // Wait for auth check to complete if not yet done
  if (!authStore.initialized) {
    await authStore.checkAuth()
  }

  // Redirect authenticated users away from guest-only pages
  if (to.meta.guestOnly && authStore.isAuthenticated) {
    return next({ name: 'dashboard' })
  }

  // Redirect unauthenticated users away from protected pages
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return next({ name: 'login', query: { redirect: to.fullPath } })
  }

  next()
})

export default router
